var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container feedback template-bg-gray my-position-relative" },
    [
      _c(
        "md-card",
        {
          staticClass:
            "request-status loop_container bg-transparent update-request-form-common"
        },
        [
          _c(
            "md-card-content",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
            [
              _c("div", { staticClass: "card form-wrapper text-center p-20" }, [
                !_vm.message.length
                  ? _c("h4", { staticClass: "template-custom-title" }, [
                      _vm._v("checking...")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "h4",
                  { staticClass: "template-custom-title", attrs: { else: "" } },
                  [_vm._v(_vm._s(_vm.message))]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a71574e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a71574e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestClose.vue
// module id = null
// module chunks = 